import { render, staticRenderFns } from "./CPDueDiligenceAccountHolderContactDetails.vue?vue&type=template&id=700982c2&scoped=true&"
import script from "./CPDueDiligenceAccountHolderContactDetails.vue?vue&type=script&lang=ts&"
export * from "./CPDueDiligenceAccountHolderContactDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700982c2",
  null
  
)

export default component.exports